import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { useNavigate } from "react-router-dom";
import { styled } from "@mui/material/styles";
import logo from "../../assets/easyCreditLogo.png";
import xpay from "../../assets/xpay.png";
import payLogo1 from "../../assets/pay-logo1.png";
import payLogo2 from "../../assets/pay-logo2.svg";
import payLogo3 from "../../assets/pay-logo3.svg";
import payLogo4 from "../../assets/pay-logo4.svg";
import "../../App.css";
import ImageSlider from "../../components/Carousel/ImageSlider";
import EasyCreditBenefit from "../../components/EasyCreditBenefit";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  InputAdornment,
  Link,
  Stack,
} from "@mui/material";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import { useMediaQuery } from "@mui/material";
import ReCAPTCHA from "react-google-recaptcha";
import {
  clearSessionStorage,
  getRequest,
  postRequest,
} from "../../services/httpservice";
import { apiURL } from "../../constants/apiUrlConstants";
import { AxiosResponse } from "axios";
import InfoIcon from "@mui/icons-material/Info";
import { useDispatch } from "react-redux";
import { setCivilIdAction } from "../../Redux/actions";
import Loader from "../../components/Loader";
import { setEmailStatus } from "../../utils/emailStatus";
import RequestQuoteOutlinedIcon from "@mui/icons-material/RequestQuoteOutlined";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import GppGoodOutlinedIcon from "@mui/icons-material/GppGoodOutlined";
import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined";
import axios, { AxiosError } from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import CryptoJS from "crypto-js"; // Import the crypto-js library
import LanguageSwitcher from "../../components/LanguageSwitcher";


export interface UserVerificationResponse {
  civilId: string;
  email: string;
  phoneNo: string;
  status: string;
  name: string;
  nameArabic: string;
  message: string;
}

interface VerifyOtpRequest {
  civilId: string;
  mobileNumber: string;
  otp: number;
  // ipAddress: string;
}

interface VerifyOtpResponse {
  accessToken: string;
  message: string;
  success: boolean;
}

interface SendOTPRequest {
  commonString: string;
}

interface SendOTPResponseItem {
  id: number;
  iUserId: number;
  iOTP: number;
  bIsSmsSent: boolean;
  dtSmsSentDate: string;
  szSmsRequest: string | null;
  szSmsResponse: string | null;
  szPhoneNumber: string;
  bIsActive: boolean;
  dtCreatedDate: string;
  dtModifiedDate: string;
}

export default function Verification() {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const isMobile = useMediaQuery("(max-width:899px)");

  const getLocalizedMessage = (message: string) => {
    const parts = message.split("/");
    if (i18n.language === "ar" && parts.length > 1) {
      return parts[1].trim();
    }
    return parts[0].trim();
  };
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [civilId, setCivilId] = useState("");
  const [civilIdInput, setCivilIdInput] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [maskedPhoneNumber, setMaskedPhoneNumber] = useState("");
  const [otp, setOtp] = useState<string>("");
  const [siteKey, setSiteKey] = useState(process.env.REACT_APP_RECAPTCHA);
  const [civilIdError, setCivilIdError] = useState("");
  const [IpAddressError, setIpAddressError] = useState("");
  const [phoneNumberError, setPhoneNumberError] = useState("");
  const [phoneNumberSuccess, setPhoneNumberSuccess] = useState(false);
  const [otpError, setOtpError] = useState("");
  const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);
  const [resendOTP, setresendOTP] = useState(false);
  const [resendOTPMessage, setresendOTPMessage] = useState(false);
  const [verified, isVerified] = useState(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [toastCloseInMs, setToastCloseInMs] = useState<number>(0);
  // const [counter, setCounter] = useState(0);
  const [masterApp, setMasterApp] = useState<string>("");
  const openPopup = () => setOpen(true);
  const closePopup = () => setOpen(false);
  const [otpTimer, setOtpTimer] = useState(0);
  const [isVisibleDidNotRec, setIsVisibleDidNotRec] = useState(false);

  useEffect(() => {
    if (otpTimer <= 0) return;
    const timer = setTimeout(() => {
      setOtpTimer((prev) => prev - 1);
    }, 1000);
    return () => clearTimeout(timer);
  }, [otpTimer]);

  const formatTimer = (seconds: number) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return (m > 9 ? "" + m : "0" + m) + ":" + (s > 9 ? "" + s : "0" + s);
  };

  // const encrypt = (data: string) => {
  //   const key = CryptoJS.enc.Base64.parse(masterApp);
  //   const utf8Data = CryptoJS.enc.Utf8.parse(data); // Explicitly convert data to UTF-8
  //   const encrypted = CryptoJS.AES.encrypt(utf8Data, key, {
  //     mode: CryptoJS.mode.ECB,
  //     padding: CryptoJS.pad.Pkcs7,
  //   });
  //   return encrypted.toString();
  // };

  // const decrypt = (data: string) => {
  //   const key = CryptoJS.enc.Base64.parse(masterApp);
  //   const decrypted = CryptoJS.AES.decrypt(data, key, {
  //     mode: CryptoJS.mode.ECB,
  //     padding: CryptoJS.pad.Pkcs7,
  //   });
  //   return decrypted.toString(CryptoJS.enc.Utf8);
  // };

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    openPopup();
  };

  const showModal = () => {
    isVerified(true);
    openPopup();
  };

  const onChangeCaptcha = () => {
    setIsCaptchaVerified(true);
  };

  const handleClose = () => {
    closePopup();
    navigate("/home/deals");
  };

  const CssTextField = styled(TextField)({
    "& label.Mui-focused": {
      color: "#f2f2f2",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#f2f2f2",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#f2f2f2",
      },
      "&:hover fieldset": {
        borderColor: "#f2f2f2",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#f2f2f2",
      },
    },
  });

  const getRecaptcha = async () => {
    try {
      const axiosResponse: AxiosResponse = await getRequest(
        process.env.REACT_APP_API_URL + apiURL.GET_RECAPTCHA
      );

      // Check if axiosResponse is not null or undefined
      if (axiosResponse) {
        if (axiosResponse.data === "") {
          toast.error(process.env.REACT_APP_ERROR_MSG);
          return;
        }

        //         const demo ={
        //     "captchaKey": "6Lfb2yUtAAAAAFNElo7qOCPFgBi-Qv9Mu5T1vBpE",
        //     "masterApp": "test12346LfBpE56789"
        // }
        setSiteKey(axiosResponse.data.captchaKey);
        const data = axiosResponse.data.masterApp;
        const modified =
          data.slice(0, 8) +
          data.slice(14);
        setMasterApp(modified);
      } else {
        // Handle the case where axiosResponse is null or undefined
        console.error("axiosResponse is null or undefined");
      }
    } catch (error: any) {
      toast.dismiss();
      toast.error(process.env.REACT_APP_ERROR_MSG);
      // Handle any errors that occurred during the request
      console.error("Error fetching data:", error);
    }
  };

  const handleCivilIdBlur = async (resendOtpKey: string) => {
    try {
      setIsLoading(true);
      setOtpError("");
      setCivilIdError("");
      setPhoneNumberError("");
      if (civilIdInput !== "") {
        setCivilId(civilIdInput);
        const payload = {
          civilId: civilIdInput,
          resendOtpKey: resendOtpKey,
        };
        const axiosResponse: AxiosResponse<any> = await postRequest(
          process.env.REACT_APP_API_URL + apiURL.GET_LOGINDETAILS,
          payload
        );
        if (
          axiosResponse !== undefined &&
          axiosResponse !== null &&
          axiosResponse.data !== null &&
          axiosResponse.data !== undefined &&
          axiosResponse.data !== ""
        ) {
          if (axiosResponse.status === 401) {
            toast.error("Session expired");
            clearSessionStorage();
            setTimeout(() => {
              navigate("/");
            }, 2000);
          }

          const encryptedData: UserVerificationResponse = axiosResponse.data;
          //const encryptedData = axiosResponse.data;

          if (
            encryptedData.status.toLocaleLowerCase() === "e" &&
            encryptedData.message.toLocaleLowerCase().includes("attempt")
          ) {
            setIpAddressError(encryptedData.message);
          }
          const userVerificationResponse = {
            civilId: encryptedData.civilId,
            email: encryptedData.email,
            phoneNo: encryptedData.phoneNo,
            name: encryptedData.name,
            nameArabic: encryptedData.nameArabic,
            status: encryptedData.status,
            message: encryptedData.message,
          };

          if (
            userVerificationResponse &&
            userVerificationResponse.email &&
            !userVerificationResponse.email.toLocaleLowerCase().includes("null")
          ) {
            setEmailStatus(true);
          } else {
            setEmailStatus(false);
          }

          if (
            userVerificationResponse.status.toLocaleLowerCase() === "e" &&
            userVerificationResponse.message
              .toLocaleLowerCase()
              .includes("civil")
          ) {
            setCivilIdError(getLocalizedMessage(userVerificationResponse.message));
            toast.error(getLocalizedMessage(userVerificationResponse.message), {
              autoClose: 2000,
            });
            setIsLoading(false);
            return;
          }

          if (
            userVerificationResponse.status.toLocaleLowerCase() === "e" &&
            userVerificationResponse.message
              .toLocaleLowerCase()
              .includes("phone")
          ) {
            setPhoneNumberError(getLocalizedMessage(userVerificationResponse.message));
          }

          if (userVerificationResponse.status.toLocaleLowerCase() === "e") {
            toast.error(getLocalizedMessage(userVerificationResponse.message), {
              autoClose: 10000,
            });
          }

          if (userVerificationResponse.status.toLocaleLowerCase() === "s") {
            setCivilId(userVerificationResponse.civilId);
            setCivilIdInput(userVerificationResponse.civilId);
            dispatch(setCivilIdAction(userVerificationResponse.civilId));
            sessionStorage.setItem("civilId", userVerificationResponse.civilId);
            sessionStorage.setItem("name", userVerificationResponse.name);
            sessionStorage.setItem(
              "nameArabic",
              userVerificationResponse.nameArabic
            );
            // sessionStorage.setItem('nameArabic', "امتحان");

            if (userVerificationResponse.phoneNo) {

              const maskedNumber =
                "+" + userVerificationResponse.phoneNo.slice(0, 3) +
                " **** " +
                userVerificationResponse.phoneNo.slice(-4);

              setMaskedPhoneNumber(maskedNumber);
              setPhoneNumber(userVerificationResponse.phoneNo);
              if (resendOtpKey === "00") setPhoneNumberSuccess(true);
              //setCounter(59);
              const otpInMint = process.env.REACT_APP_OTP_VALIDATION_IN_MINT;
              if (otpInMint) {
                setOtpTimer(parseInt(otpInMint) * 60);
                setTimeout(() => {
                  setIsVisibleDidNotRec(true);
                }, 5000);
              }
              isVerified(true);
              setCivilIdError("");
              setPhoneNumberError("");
            }
          } else {
            setIpAddressError(userVerificationResponse.message);
          }
          setIsLoading(false);
        } else {
          if (axiosResponse?.status === 401) {
            toast.error("Session expired");
            clearSessionStorage();
            setTimeout(() => {
              navigate("/");
            }, 2000);
            return;
          }
          toast.error(process.env.REACT_APP_ERROR_MSG);
          setIsLoading(false);
        }
      }
    } catch (error) {
      setIsLoading(false);
      if (axios.isAxiosError(error)) {
        toast.dismiss();
        const axiosError = error as AxiosError;
        if (axiosError.response) {
          if (axiosError?.response.status === 401) {
            toast.error("Session expired");
            clearSessionStorage();
            setTimeout(() => {
              navigate("/");
            }, 2000);
          } else {
            toast.error(process.env.REACT_APP_ERROR_MSG);
          }
        }
      }
    }
  };

  useEffect(() => {
    getRecaptcha();
    setOtpTimer(0);
    const msToast = process.env.REACT_APP_TOAST_CLOSE_IN_SECONDS;
    if (msToast) {
      setToastCloseInMs(parseInt(msToast));
    }
  }, []);

  // useEffect(() => {
  //   if (verified) {
  //     const interval = setInterval(() => {
  //       if (counter > 0) {
  //         setCounter(counter - 1);
  //       }
  //     }, 1000);

  //     return () => {
  //       clearInterval(interval);
  //     };
  //   }
  // }, [isVerified, counter]);

  const handleCivilIdChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const cleanedValue = event.target.value.replace(/\D/g, "");
    const truncatedValue = cleanedValue.slice(0, 12);
    setCivilIdError("");
    setCivilId(truncatedValue);
    setCivilIdInput(truncatedValue);
  };

  const handleOTPChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const cleanedValue = event.target.value.replace(/\D/g, "");
    const truncatedValue = cleanedValue.slice(0, 12);
    setOtp(truncatedValue);
  };

  const handleVerifyOTP = async () => {
    try {
      setIsLoading(true);
      const requestPayload: VerifyOtpRequest = {
        civilId: civilId,
        mobileNumber: phoneNumber,
        otp: Number(otp),
      };
      const axiosResponse: AxiosResponse<any> = await postRequest(
        process.env.REACT_APP_API_URL + apiURL.VERIFY_OTP,
        requestPayload
      );
      if (axiosResponse == null) {
        toast.dismiss();
        toast.error(process.env.REACT_APP_ERROR_MSG);
        return;
      }
      if (axiosResponse.data === "") {
        toast.dismiss();
        toast.error(process.env.REACT_APP_ERROR_MSG);
        return;
      }
      const verifyOtpResponse: VerifyOtpResponse = axiosResponse.data;

      if (
        !verifyOtpResponse.success &&
        verifyOtpResponse.message.toLocaleLowerCase().includes("otp")
      ) {
        setresendOTPMessage(false);
        setOtpError(verifyOtpResponse.message);
      } else {
        setresendOTPMessage(false);
        setOtpError(verifyOtpResponse.message);
      }

      if (verifyOtpResponse && verifyOtpResponse.success) {
        sessionStorage.setItem("accessToken", verifyOtpResponse.accessToken);
        setIsCaptchaVerified(false);
        setCivilId("");
        setCivilIdInput("");
        setPhoneNumber("");
        setOtp("");
        setCivilIdError("");
        setPhoneNumberError("");
        setOtpError("");
        openPopup();
        setOtpTimer(0);
      } else {
        if (
          verifyOtpResponse.message !== null &&
          verifyOtpResponse.message !== ""
        ) {
          if (verifyOtpResponse.message.includes("OTP Expired")) {
            //setCounter(0);
            setOtpTimer(0);
          }
        }
      }
      setIsLoading(false);
    } catch (error: any) {
      toast.dismiss();
      toast.error(process.env.REACT_APP_ERROR_MSG);
    }
  };

  const handleVerify = () => {
    if (civilId) {
      handleCivilIdBlur("00");
    }
  };

  const handleResendOTP = () => {
    setIsVisibleDidNotRec(false);
    setPhoneNumberSuccess(false);
    setresendOTPMessage(true);
    setresendOTP(false);
    handleCivilIdBlur("01");
  };

  useEffect(() => {
    window.history.replaceState(null, "", window.location.href);
  }, []);
  return (
    <>
      {isLoading && <Loader />}
      {isMobile ? (
        //Mobile view
        <div
          style={{
            backgroundSize: "cover",
            height: "100vh",
            color: "#f5f5f5",
            marginTop: 4,
          }}
        >
          <Stack
            direction="column"
            spacing={1}
            justifyContent="center"
            alignItems="center"
            minWidth="375px"
          >
            <Stack
              direction="column"
              spacing={1}
              justifyContent="center"
              alignItems="center"
            >
              <Box style={{ height: "90vh", minHeight: "500px" }}>
                <Box sx={{ color: "#00365C", textAlign: "left" }}>
                  <Typography component="div">
                    <Grid>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "end",
                          width: "100%",
                        }}
                      >
                        {/* <img
                          src={xpay}
                          alt="Logo"
                          style={{
                            width: "88",
                            height: 49,
                          }}
                        /> */}
                        <LanguageSwitcher />
                      </Box>
                      <Box
                        sx={{
                          fontWeight: "bold",
                          m: 2,
                          fontSize: "20px",
                          textAlign: "start",
                        }}
                      >
                        {t("verification.welcomeTitle")}
                      </Box>
                      <Box sx={{ m: 2, fontSize: "12px", textAlign: "left" }}>
                        {/* {t('verification.welcomeDesc')} */}
                      </Box>
                    </Grid>
                  </Typography>
                </Box>
                <Grid
                  container
                  sx={{ justifyContent: "center", marginTop: "0.8rem" }}
                ></Grid>

                {/* Form Grid */}
                <Grid item xs={12} sm={12} lg={5} maxWidth="560px">
                  <Box
                    style={{
                      padding: "5px",
                      height: "auto",
                      minHeight: "500px",
                      backgroundColor: "#2A92BD",
                      color: "#f5f5f5",
                    }}
                  >
                    <Container>
                      <Box sx={{ paddingTop: "20px", textAlign: "left" }}>
                        <div>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between",
                            }}
                          ></Box>
                        </div>
                      </Box>
                      <Box
                        component="form"
                        noValidate
                        onSubmit={handleSubmit}
                        sx={{ mt: 3 }}
                      >
                        <Typography
                          sx={{
                            color: "#ffffff",
                            fontSize: "18px",
                            fontWeight: "bold",
                            textAlign: "left",
                          }}
                        >
                          {t("verification.details")}
                        </Typography>
                        {/* <hr /> */}
                        <span>
                          <hr style={{ border: "1px solid white" }} />
                        </span>
                        <Grid container spacing={1}>
                          {!verified ? (
                            <Grid item xs={12}>
                              <TextField
                                fullWidth
                                label={t("verification.civilId")}
                                className="myTextField"
                                sx={{
                                  my: 2,
                                  input: { color: "#fff" },
                                  label: { color: "#fff" },
                                }}
                                value={civilIdInput}
                                autoComplete="off"
                                onChange={handleCivilIdChange}
                                inputProps={{
                                  inputMode: "numeric",
                                  pattern: "[0-9]*",
                                  maxLength: 12,
                                }}
                              />
                              <Grid item xs={12} sx={{ minHeight: "78px" }}>
                                {siteKey && (
                                  <div
                                    style={{
                                      width: "100%",
                                      maxWidth: "100%",
                                      overflow: "hidden",
                                    }}
                                  >
                                    <div
                                      style={{
                                        width: "100%",
                                        transformOrigin: "0 0",
                                      }}
                                      className="recaptcha-wrapper"
                                    >
                                      <ReCAPTCHA
                                        sitekey={siteKey}
                                        onChange={onChangeCaptcha}
                                      />
                                    </div>
                                  </div>
                                )}
                              </Grid>

                              {civilIdError && (
                                <Box sx={{ display: "flex", alignItems: "center", background: "#FFCDD2", color: "#FF0000", fontSize: "small", px: 1, py: 0.5, borderRadius: 1, mt: 2 }}>
                                  <InfoIcon />
                                  <span style={{ marginLeft: "8px" }} dangerouslySetInnerHTML={{ __html: civilIdError }}></span>
                                </Box>
                              )}
                              {phoneNumberError && (
                                <Box sx={{ display: "flex", alignItems: "center", background: "#FFCDD2", color: "#FF0000", fontSize: "small", px: 1, py: 0.5, borderRadius: 1, mt: 2 }}>
                                  <InfoIcon />
                                  <span style={{ marginLeft: "8px" }}>{phoneNumberError}</span>
                                </Box>
                              )}

                              <Grid item xs={12} sx={{ my: 3 }}>
                                <span
                                  style={{
                                    marginLeft: "8px",
                                    color: "#CC3434",
                                    fontWeight: "bold",
                                    marginBottom: "15px",
                                    display: "block",
                                  }}
                                >
                                  {IpAddressError}
                                </span>
                                <Button
                                  variant="contained"
                                  size="small"
                                  fullWidth
                                  sx={{
                                    py: 1,
                                    height: "50px",
                                    color: "#ffffff",
                                    backgroundColor: "#00365C",
                                    fontWeight: "bold",
                                    boxShadow: 0,
                                    mt: 2,
                                    "&:hover": {
                                      backgroundColor: "#00365C",
                                      boxShadow: "none",
                                    },
                                  }}
                                  //  onClick={showModal}
                                  onClick={handleVerify}
                                  disabled={!(civilId && isCaptchaVerified)}
                                >
                                  {t("common.verify")}
                                </Button>
                              </Grid>
                            </Grid>
                          ) : (
                            <Grid item xs={12} sx={{ mx: 1 }}>
                              {/* {isLoading && <Loader />} */}
                              <TextField
                                fullWidth
                                label={t("verification.civilId")}
                                className="myTextField"
                                sx={{
                                  my: 2,
                                  input: { color: "#fff" },
                                  label: { color: "#fff" },
                                }}
                                value={civilId}
                                inputProps={{
                                  inputMode: "numeric",
                                  pattern: "[0-9]*",
                                  maxLength: 12,
                                }}
                              />
                              <CssTextField
                                fullWidth
                                size="medium"
                                label={t("verification.phoneNumber")}
                                sx={{
                                  my: 2,
                                  input: { color: "#fff" },
                                  label: { color: "#fff" },
                                }}
                                value={maskedPhoneNumber}
                                inputProps={{ dir: "ltr", style: { textAlign: i18n.language === "ar" ? "right" : "left" } }}
                              />

                              <TextField
                                fullWidth
                                size="medium"
                                label={t("verification.otp")}
                                className="myTextField"
                                sx={{
                                  my: 2,
                                  input: { color: "#fff" },
                                  label: { color: "#fff" },
                                }}
                                value={otp}
                                onChange={handleOTPChange}
                                inputProps={{
                                  inputMode: "numeric",
                                  pattern: "[0-9]*",
                                  maxLength: 6,
                                }}
                                InputProps={{
                                  endAdornment: otpTimer > 0 ? (
                                    <InputAdornment position="end">
                                      <Typography sx={{ color: "#fff", fontSize: "14px", whiteSpace: "nowrap" }}>
                                        {formatTimer(otpTimer)}
                                      </Typography>
                                    </InputAdornment>
                                  ) : undefined,
                                }}
                              />
                              {phoneNumberSuccess && !otpError && (
                                <Box sx={{ display: "flex", alignItems: "center", background: "#C8E6C9", color: "#388E3C", fontSize: "small", px: 1, py: 0.5, borderRadius: 1, mb: 1 }}>
                                  <InfoIcon />
                                  <span style={{ marginLeft: "8px" }}>{t("verification.enterOtpSentTo")} <span dir="ltr" style={{ whiteSpace: "nowrap" }}>{maskedPhoneNumber}</span></span>
                                </Box>
                              )}
                              {resendOTPMessage && !otpError && (
                                <Box sx={{ display: "flex", alignItems: "center", background: "#C8E6C9", color: "#388E3C", fontSize: "small", px: 1, py: 0.5, borderRadius: 1, mb: 1 }}>
                                  <InfoIcon />
                                  <span style={{ marginLeft: "8px" }}>{t("verification.otpResent")} <span dir="ltr" style={{ whiteSpace: "nowrap" }}>{maskedPhoneNumber}</span></span>
                                </Box>
                              )}
                              {otpError && (
                                <Box sx={{ display: "flex", alignItems: "center", background: "#FFCDD2", color: "#FF0000", fontSize: "small", px: 1, py: 0.5, borderRadius: 1, mb: 1 }}>
                                  <InfoIcon />
                                  <span style={{ marginLeft: "8px" }}>{getLocalizedMessage(otpError)}</span>
                                </Box>
                              )}
                              {isVisibleDidNotRec && otpTimer <= 0 && (
                                <Box
                                  sx={{
                                    textAlign: "start",
                                    color: "#fff",
                                    fontSize: "small",
                                    fontWeight: "400",
                                    py: 0.5,
                                    borderRadius: 1,
                                  }}
                                >
                                  {t("verification.didntReceiveOtp")}
                                  <Link
                                    onClick={handleResendOTP}
                                    underline="always"
                                    sx={{
                                      color: "#fff",
                                      ml: "5px",
                                      textDecorationColor: "#fff",
                                      cursor: "pointer",
                                    }}
                                  >
                                    {t("verification.resend")}
                                  </Link>
                                </Box>
                              )}
                              <Grid item xs={12} sx={{ my: 2 }}>
                                <Button
                                  variant="contained"
                                  size="small"
                                  fullWidth
                                  sx={{
                                    py: 1,
                                    height: "50px",
                                    color: "#ffffff",
                                    backgroundColor: "#00365C",
                                    fontWeight: "bold",
                                    boxShadow: 0,
                                    mt: 2,
                                    "&:hover": {
                                      backgroundColor: "#00365C",
                                      boxShadow: "none",
                                    },
                                  }}
                                  onClick={handleVerifyOTP}
                                  disabled={!otp}
                                >
                                  {t("common.submit")}
                                </Button>
                                {/* Modal */}
                                <Box>
                                  <Dialog
                                    open={open}
                                    onClose={closePopup}
                                    maxWidth="xs"
                                    fullWidth
                                    sx={{ borderRadius: "70px" }}
                                  >
                                    <DialogContent
                                      sx={{
                                        backgroundColor: "#2A92BD",
                                        padding: "40px",
                                      }}
                                    >
                                      <DialogContent
                                        sx={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          backgroundColor: "#42AF3C",
                                          borderRadius: "50%",
                                          padding: "20px",
                                          position: "absolute",
                                          top: "35px",
                                          left: "40%",
                                        }}
                                      >
                                        <ThumbUpIcon
                                          fontSize="large"
                                          style={{ color: "#FFFFFF" }}
                                        />
                                      </DialogContent>
                                    </DialogContent>
                                    <DialogContent>
                                      <DialogContentText
                                        sx={{
                                          color: "#0F426A",
                                          textAlign: "center",
                                          fontWeight: "bold",
                                          fontSize: "24px",
                                          mt: 8,
                                          mb: 5,
                                        }}
                                      >
                                        {t("verification.verifiedSuccessfully")}
                                      </DialogContentText>
                                      <DialogActions
                                        sx={{ justifyContent: "center" }}
                                      >
                                        <Button
                                          size="large"
                                          sx={{
                                            py: 1,
                                            height: "50px",
                                            width: "25vw",
                                            color: "#ffffff",
                                            backgroundColor: "#2A92BD",
                                            fontWeight: "bold",
                                            boxShadow: 0,
                                            "&:hover": {
                                              backgroundColor: "#00365C",
                                              boxShadow: "none",
                                            },
                                          }}
                                          variant="contained"
                                          onClick={handleClose}
                                        >
                                          OK
                                        </Button>
                                      </DialogActions>
                                    </DialogContent>
                                  </Dialog>
                                </Box>
                              </Grid>
                            </Grid>
                          )}
                        </Grid>
                      </Box>
                    </Container>
                  </Box>
                </Grid>

                {/* Info Container */}
                <Box sx={{ mt: 5 }}>
                  <Stack
                    direction="column"
                    spacing={1}
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                      <Box
                        sx={{
                          color: "#00365C",
                          textAlign: "left",
                          minWidth: "300px",
                          minHeight: "300px",
                        }}
                      >
                        <ImageSlider />
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                      <Box sx={{ color: "#00365C", textAlign: "left", p: 2 }}>
                        <EasyCreditBenefit />
                      </Box>
                    </Grid>
                  </Stack>
                </Box>
              </Box>
            </Stack>
          </Stack>
        </div>
      ) : (
        // Desktop View
        <Container
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            minWidth: "100%",
            color: "#f5f5f5",
            width: "100%",
            height: "100vh",
            backgroundColor: "#DDEAEC",
            p: 7,
          }}
        >
          <Grid
            id="innerGrid"
            item
            xs={12}
            sm={12}
            lg={6}
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "column", md: "row" },
              justifyContent: "space-between",
              bgcolor: "background.paper",
              borderRadius: "20px",
              position: "relative",
            }}
          >
            {/* info  */}"
            <Stack sx={{ p: 3 }}>
              <Box sx={{ color: "#00365C", textAlign: "left" }}>
                <Typography component="div">
                  <Grid sx={{ px: 1 }}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "end",
                        width: "100%",
                      }}
                    >
                      {/* <img
                        src={xpay}
                        alt="Logo"
                        style={{
                          width: "88",
                          height: 49,
                        }}
                      /> */}
                      <LanguageSwitcher />
                    </Box>
                    <Box
                      sx={{
                        fontWeight: "bold",
                        mt: 1,
                        fontSize: "20px",
                        width: "557px",
                        textAlign: "start",
                      }}
                    >
                      {t("verification.welcomeTitle")}
                    </Box>
                    <Box sx={{ mt: 2, fontSize: "12px", textAlign: "left" }}>
                      {/* {t('verification.welcomeDesc')} */}
                    </Box>
                  </Grid>
                </Typography>
              </Box>
              <Grid
                container
                sx={{ justifyContent: "center", marginTop: "0.6rem" }}
              ></Grid>

              <Box sx={{ mt: 3 }}>
                <Grid container>
                  <Grid item xs={12} sm={12} md={6} lg={6}>
                    <Box sx={{ color: "#00365C", textAlign: "left" }}>
                      <ImageSlider />
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={6}>
                    <Box sx={{ color: "#00365C", textAlign: "left", px: 2 }}>
                      <EasyCreditBenefit />
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Stack>
            {/* form */}
            <Stack sx={{ height: "100%" }}>
              <Grid
                item
                xs={12}
                sm={12}
                lg={6}
                sx={{ maxWidth: "365px", minWidth: "365px", height: "100%" }}
              >
                <Box
                  sx={{
                    borderStartStartRadius: 0,
                    borderEndStartRadius: 0,
                    borderStartEndRadius: "20px",
                    borderEndEndRadius: "20px",
                    height: "100%",
                    backgroundColor: "#2A92BD",
                    color: "#f5f5f5",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Container sx={{ p: 2, display: "flex", flexDirection: "column", flex: 1 }}>
                    <Box
                      component="form"
                      noValidate
                      onSubmit={handleSubmit}
                      sx={{ mt: 3, display: "flex", flexDirection: "column", flex: 1 }}
                    >
                      {/* marginBottom:'15px' */}
                      <Typography
                        sx={{
                          color: "#ffffff",
                          fontSize: "18px",
                          fontWeight: "bold",
                          textAlign: "start",
                          marginTop: "0px",
                        }}
                      >
                        {t('common.login')}
                      </Typography>
                      {/* <hr /> */}
                      <span>
                        <hr style={{ border: "1px solid white" }} />
                      </span>

                      {/* Form view 1  */}
                      {!verified ? (
                        <>
                          <Box sx={{ px: 1 }}>
                            <TextField
                              fullWidth
                              label={t("verification.civilId")}
                              className="myTextField"
                              sx={{
                                my: 2,
                                input: { color: "#fff" },
                                label: { color: "#fff" },
                              }}
                              value={civilIdInput}
                              autoComplete="off"
                              onChange={handleCivilIdChange}
                              inputProps={{
                                inputMode: "numeric",
                                pattern: "[0-9]*",
                                maxLength: 12,
                              }}
                            />
                            <Box sx={{ minHeight: "78px", overflow: "hidden" }}>
                              {siteKey && (
                                <ReCAPTCHA
                                  key={i18n.language}
                                  style={{ width: "100%" }}
                                  sitekey={siteKey}
                                  onChange={onChangeCaptcha}
                                  hl={i18n.language}
                                />
                              )}
                            </Box>
                            {civilIdError && (
                              <Box sx={{ display: "flex", alignItems: "center", background: "#FFCDD2", color: "#FF0000", fontSize: "small", px: 1, py: 0.5, borderRadius: 1, mt: 1 }}>
                                <InfoIcon />
                                <span style={{ marginLeft: "8px" }} dangerouslySetInnerHTML={{ __html: civilIdError }}></span>
                              </Box>
                            )}
                            {phoneNumberError && (
                              <Box sx={{ display: "flex", alignItems: "center", background: "#FFCDD2", color: "#FF0000", fontSize: "small", px: 1, py: 0.5, borderRadius: 1, mt: 1 }}>
                                <InfoIcon />
                                <span style={{ marginLeft: "8px" }}>{phoneNumberError}</span>
                              </Box>
                            )}
                            {IpAddressError && (
                              <span style={{ color: "red", fontWeight: "bold", marginTop: "8px", display: "block" }}>
                                {IpAddressError}
                              </span>
                            )}
                          </Box>

                          <Box sx={{ px: 1, mt: "auto", pb: 2 }}>
                            <Button
                              variant="contained"
                              size="small"
                              fullWidth
                              sx={{
                                py: 1, height: "40px", color: "#ffffff",
                                backgroundColor: "#00365C", fontWeight: "bold",
                                boxShadow: 0, mt: 1,
                                "&:hover": { backgroundColor: "#00365C", boxShadow: "none" },
                              }}
                              onClick={handleVerify}
                              disabled={!(civilId && isCaptchaVerified)}
                            >
                              {t("common.verify")}
                            </Button>
                          </Box>
                        </>
                      ) : (
                        // Form View 2
                        <>
                          <Box sx={{ px: 1 }}>
                            <TextField
                              fullWidth
                              label="Civil ID"
                              className="myTextField"
                              sx={{ my: 2, input: { color: "#fff" }, label: { color: "#fff" } }}
                              value={civilId}
                              inputProps={{ inputMode: "numeric", pattern: "[0-9]*", maxLength: 12 }}
                            />
                            <CssTextField
                              fullWidth
                              size="medium"
                              label={t("verification.phoneNumber")}
                              sx={{ my: 2, input: { color: "#fff" }, label: { color: "#fff" } }}
                              value={maskedPhoneNumber}
                              inputProps={{ dir: "ltr", style: { textAlign: i18n.language === "ar" ? "right" : "left" } }}
                            />
                            <TextField
                              autoComplete="off"
                              fullWidth
                              size="medium"
                              label={t("verification.otp")}
                              className="myTextField"
                              sx={{ my: 2, input: { color: "#fff" }, label: { color: "#fff" } }}
                              value={otp}
                              onChange={handleOTPChange}
                              inputProps={{ inputMode: "numeric", pattern: "[0-9]*", maxLength: 6 }}
                              InputProps={{
                                endAdornment: otpTimer > 0 ? (
                                  <InputAdornment position="end">
                                    <Typography sx={{ color: "#fff", fontSize: "14px", whiteSpace: "nowrap" }}>
                                      {formatTimer(otpTimer)}
                                    </Typography>
                                  </InputAdornment>
                                ) : undefined,
                              }}
                            />
                            {phoneNumberSuccess && !otpError && (
                              <Box sx={{ display: "flex", alignItems: "center", background: "#C8E6C9", color: "#388E3C", fontSize: "small", px: 1, py: 0.5, borderRadius: 1, mb: 1 }}>
                                <InfoIcon />
                                <span style={{ marginLeft: "8px" }}>{t("verification.enterOtpSentTo")} <span dir="ltr" style={{ whiteSpace: "nowrap" }}>{maskedPhoneNumber}</span></span>
                              </Box>
                            )}
                            {resendOTPMessage && !otpError && (
                              <Box sx={{ display: "flex", alignItems: "center", background: "#C8E6C9", color: "#388E3C", fontSize: "small", px: 1, py: 0.5, borderRadius: 1, mb: 1 }}>
                                <InfoIcon />
                                <span style={{ marginLeft: "8px" }}>{t("verification.otpResent")} <span dir="ltr" style={{ whiteSpace: "nowrap" }}>{maskedPhoneNumber}</span></span>
                              </Box>
                            )}
                            {otpError && (
                              <Box sx={{ display: "flex", alignItems: "center", background: "#FFCDD2", color: "#FF0000", fontSize: "small", px: 1, py: 0.5, borderRadius: 1, mb: 1 }}>
                                <InfoIcon />
                                <span style={{ marginLeft: "8px" }}>{getLocalizedMessage(otpError)}</span>
                              </Box>
                            )}
                            {isVisibleDidNotRec && otpTimer <= 0 && (
                              <Box sx={{ textAlign: "start", color: "#fff", fontSize: "small", fontWeight: "400", py: 0.5, borderRadius: 1 }}>
                                {t("verification.didntReceiveOtp")}
                                <Link onClick={handleResendOTP} underline="always" sx={{ color: "#fff", ml: "5px", textDecorationColor: "#fff", cursor: "pointer" }}>
                                   {t("verification.resend")}
                                </Link>
                              </Box>
                            )}
                          </Box>

                          <Box sx={{ px: 1, mt: "auto", pb: 2 }}>
                                <Button
                                  variant="contained"
                                  size="small"
                                  fullWidth
                                  sx={{
                                    py: 1,
                                    height: "40px",
                                    color: "#ffffff",
                                    backgroundColor: "#00365C",
                                    fontWeight: "bold",
                                    boxShadow: 0,
                                    mt: 1,
                                    "&:hover": {
                                      backgroundColor: "#00365C",
                                      boxShadow: "none",
                                    },
                                  }}
                                  onClick={handleVerifyOTP}
                                  disabled={!otp}
                                >
                                  {t("common.verify")}
                                </Button>
                            <Dialog

                                  open={open}
                                  onClose={closePopup}
                                  maxWidth="xs"
                                  fullWidth
                                  sx={{ borderRadius: "70px" }}
                                >
                                  <DialogContent
                                    sx={{
                                      backgroundColor: "#2A92BD",
                                      padding: "40px",
                                    }}
                                  >
                                    <DialogContent
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        backgroundColor: "#42AF3C",
                                        borderRadius: "50%",
                                        padding: "20px",
                                        position: "absolute",
                                        top: "35px",
                                        left: "40%",
                                      }}
                                    >
                                      <ThumbUpIcon
                                        fontSize="large"
                                        style={{ color: "#FFFFFF" }}
                                      />
                                    </DialogContent>
                                  </DialogContent>
                                  <DialogContent>
                                    <DialogContentText
                                      sx={{
                                        color: "#0F426A",
                                        textAlign: "center",
                                        fontWeight: "bold",
                                        fontSize: "24px",
                                        mt: 8,
                                        mb: 5,
                                      }}
                                    >
                                      <br />
                                      {t('verification.verifiedSuccessfully')}
                                    </DialogContentText>
                                    <DialogActions
                                      sx={{ justifyContent: "center" }}
                                    >
                                      <Button
                                        size="large"
                                        sx={{
                                          py: 1,
                                          height: "50px",
                                          width: "10vw",
                                          color: "#ffffff",
                                          backgroundColor: "#2A92BD",
                                          fontWeight: "bold",
                                          boxShadow: 0,
                                          "&:hover": {
                                            backgroundColor: "#00365C",
                                            boxShadow: "none",
                                          },
                                        }}
                                        variant="contained"
                                        onClick={handleClose}
                                      >
                                        {t("common.ok")}
                                      </Button>
                                    </DialogActions>
                                  </DialogContent>
                                </Dialog>
                          </Box>
                        </>
                      )}
                    </Box>
                  </Container>
                </Box>
              </Grid>
            </Stack>
          </Grid>
        </Container>
      )}

      <ToastContainer
        position="top-right"
        newestOnTop
        limit={1}
        autoClose={toastCloseInMs}
      />
    </>
  );
}
